import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HabitsQuestion } from 'src/app/analyses/interfaces/analyses.types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnalysesIdResultsMetricsServingsComponent } from 'src/app/analyses/modals/servings/servings.component';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsModule } from '@geneplanet/ngx-utils/src/lib/analytics';

enum QuestionButton {
  VEGETABLES = '8d6d4edb-3c2c-4cba-95dc-c83bc043a6c1',
  MEAT = '92f1f5f7-0d20-4ab1-b757-045027f2dd3b'
}

@Component({
  selector: 'app-examples-modal-buttons',
  standalone: true,
  imports: [CommonModule, TranslateModule, AnalyticsModule],
  templateUrl: './examples-modal-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExamplesModalButtonsComponent {
  @Input({ required: true }) question: HabitsQuestion;

  protected get button() {
    return [
      {
        questionId: QuestionButton.VEGETABLES,
        dataTrack: 'analyses-view-one-serving',
        text: 'ANALYSES.SINGLE.VIEW_ONE_SERVING',
        type: 'vegetables',
      },
      {
        questionId: QuestionButton.MEAT,
        dataTrack: 'analyses-view-example',
        text: 'ANALYSES.SINGLE.VIEW_EXAMPLE',
        type: 'meat',
      },
    ].find((b) => b.questionId === this.question.id);
  }

  private modals = inject(NgbModal);

  protected openModal(type: string): void {
    const ref = this.modals.open(AnalysesIdResultsMetricsServingsComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'basic-modal',
      backdropClass: 'basic-modal-backdrop',
    });
    ref.componentInstance.type = type;
  }
}
